<template>
    <b-tab title="Users">
        <div class="d-flex mb-3 w-auto">
            <div class="h4 mr-3">
                Users
            </div>
            <div class="ml-auto mr-2 d-flex">
                <b-button variant="success" @click.prevent="show_user_modal = true" :disabled="!can_create_users">
                    <font-awesome-icon :icon="['fad', 'plus-square']" /> Add User
                </b-button>
                <b-button
                    class="ml-2"
                    variant="outline-success"
                    @click.prevent="show_import_csv_modal = true"
                    :disabled="!can_create_users"
                >
                    <font-awesome-icon :icon="['fad', 'plus-square']" /> Import Users CSV
                </b-button>
            </div>
        </div>
        <div>
            <b-spinner v-if="loading" label="Loading..."></b-spinner>
            <b-table
                v-else
                striped
                responsive
                sticky-header
                outlined
                no-border-collapse
                head-variant="light"
                :items="users"
                :fields="fields"
            >
                <template #cell(active)="data">
                    {{ Boolean(data.value) ? 'Active': 'Disabled' }}
                </template>

                <template #cell(roles)="data">
                    <b-badge
                        variant="secondary"
                        v-for="item in data.value"
                        class="m-1"
                        :key="`${data.item.id}-role-${item.id}`"
                    >
                        {{ item.name }}
                    </b-badge>
                </template>

                <template #cell(skus)="data">
                    <b-badge
                        variant="secondary"
                        v-for="item in data.value"
                        class="m-1"
                        :key="`${data.item.id}-sku-${item.publications_id}`"
                        :title="item.title"
                        v-b-tooltip.hover
                    >
                        {{ item.sku }}
                    </b-badge>
                </template>

                <template #cell(actions)="data">
                    <b-btn
                        size="sm"
                        variant="outline-primary"
                        @click="editUser(data.item)"
                        :disabled="!can_edit_users"
                    >
                        <font-awesome-icon :icon="['fad', 'edit']" fixed-width /> Edit
                    </b-btn>
                </template>
            </b-table>
        </div>

        <user-modal
            :visible="show_user_modal"
            :selected_user="editable_user"
            @hide="clearUser"
        />
        <UsersImportCsvModal
            v-model="show_import_csv_modal"
            @hide="show_import_csv_modal = false"
            @imported="getUsers"
        />
    </b-tab>
</template>

<style></style>

<script>
import { mapState } from 'vuex'
import UserModal from '@/components/modals/admin/UserModal.vue'
import UsersImportCsvModal from '@/components/modals/admin/UsersImportCSVModal.vue'
import moment from 'moment'

export default {
    name: 'UsersTab',
    components: {UserModal, UsersImportCsvModal},
    data: () => ({
        loading: false,
        fields: [
            {
                key: 'id',
                sortable: true,
                order_number: 1,
                thStyle: {
                    'width': '5%'
                },
            },
            {
                key: 'active',
                sortable: true,
                order_number: 2,
                thStyle: {
                    'width': '5%'
                },
            },
            {
                key: 'email',
                sortable: true,
                order_number: 3,
                thStyle: {
                    'width': '15%'
                },
            },
            {
                key: 'first_name',
                sortable: true,
                order_number: 4,
                thStyle: {
                    'width': '10%'
                },
            },
            {
                key: 'last_name',
                sortable: true,
                order_number: 5,
                thStyle: {
                    'width': '10%'
                },
            },
            {
                key: 'roles',
                sortable: false,
                order_number: 6,
                thStyle: {
                    'width': '25%'
                },
            },
            {
                key: 'skus',
                sortable: false,
                order_number: 7,
                thStyle: {
                    'width': '20%'
                },
            },
            {
                key: 'actions',
                sortable: false,
                order_number: 8,
                thStyle: {
                    'width': '10%'
                },
            },
        ],
        show_user_modal: false,
        show_import_csv_modal: false,
        editable_user: null,
    }),
    computed: {
        ...mapState({
            errors: state => state.errors.errors,
            users: state => state.admin.users,
            user: state => state.user.user,
        }),
        can_create_users() {
            return this.user && this.user.permissions && _.includes(this.user.permissions, 'create_user')
        },
        can_edit_users() {
            return this.user && this.user.permissions && _.includes(this.user.permissions, 'update_user')
        },
    },
    methods: {
        editUser(user) {
            this.editable_user = user
            this.show_user_modal = true
        },
        clearUser() {
            this.editable_user = null
            this.show_user_modal = false
        },
        async getUsers() {
            try {
                this.loading = true
                await this.$store.dispatch('getAdminUsers')
                await this.$store.dispatch('getAdminSkus')
            } catch (e) {
                await this.$store.dispatch('pushError', {
                    data: {
                        message: `Failed to fetch users: ${e.message}`,
                    },
                    time: moment().toISOString(),
                })
            }

            this.loading = false
        }
    },
    mounted() {
        this.getUsers()
    }
}
</script>
